module.exports = __webpack_public_path__ + "static/img/login_new_bg.99ebe04d.png";